import { Pipe, PipeTransform } from '@angular/core';
import { UserDto } from '@lib-ui/client';

@Pipe({
  name: 'displayName',
  standalone: true,
})
export class DisplayNamePipe implements PipeTransform {

  transform(user: UserDto): string {
    return `${user.firstName} ${user.lastName} (${user.mail})`;
  }

}
